"use strict";

//	Kilopix

import * as kpc from "../@kilopix/core.module";
import * as kpm from "../@kilopix/methods.module";
import * as kpu from "../@kilopix/utils.module";

//	Modules

import { AppInterface, activeImageDisplacement } from "./app.interface";
import { Slider } from "./slider/slider.component";
import { Article } from "./article/article.component";
import { Footer } from "./footer/footer.component";
import { BurgerButton } from "./burger-button/burger-button.component";
import { CookieBanner } from "./cookie-banner/cookie-banner.component";
import { DevGrid } from "./dev-grid/dev-grid.component";

//	Component instances

const slider = new Slider();
const burgerButton = new BurgerButton();

//	Dom selectors

const html = document.querySelector( "html" );
const appBody = document.getElementById( "body" );

//	App

export class App {
	constructor() {
		this.resizeTimeout = null;
		this.mobileClass = ( kpu.isMobile() ) ? "mobile" : "no-mobile";
	}

//	Run

	run() {
		kpm.removeClass( html, "no-js" );
		kpm.addClass( html, `js ${this.mobileClass}` );

		window.addEventListener( "load", () => { this.load(); } );
		window.addEventListener( "scroll", () => { this.scroll(); } );
		window.addEventListener( "resize", () => { this.resize(500); } );

		if ( kpm.hasClass(document.body, "homepage") ) {
			slider.run();
		}

		if ( !kpu.isMobile() ) {
			activeImageDisplacement( document.querySelectorAll(".has-displacement") );
		}

		Footer.run();

		if ( document.location.hostname === "localhost" ) {
			DevGrid.render();
		}

		this.resize( 0 );

		/**
		 *	Rendo globale la funzione che gestisce le operazioni di accettazione
		 *	dei cookies. Passaggio obbligato visto che la chiamata alla funzione
		 *	avviene inline, nel tag html
		 */

		window.masterCookieConsentSet = CookieBanner.consentSet;
	}

//	Load

	load() {
	}

//	Resize

	resize( delay ) {
		AppInterface.appMediaQuery = kpc.getMediaQuery();
		AppInterface.appSize = kpc.getSize();
		AppInterface.appOrientation = kpc.getOrientation();
		
		kpm.addClass( html, "no-transition" );

		clearTimeout( this.resizeTimeout );
		this.resizeTimeout = setTimeout( () => {
			kpm.removeClass( html, "no-transition" );
			CookieBanner.resizeSpacer();
		}, delay );

		if ( kpm.hasClass(document.body, "homepage") ) {
			slider.resize();
		}

		Footer.resize();
		burgerButton.resize();

		this.scroll();
	}

//	Scroll

	scroll() {
		AppInterface.scrollTop = kpc.getScrollTop();
		AppInterface.scrollBottom = kpc.getScrollBottom();
		AppInterface.scrollPerc = kpc.getScrollPerc();
		AppInterface.scrollDirection = kpc.getScrollDirection();

		if ( document.getElementById("article") ) {
			Article.scroll();
		}
	}
}